import { Vehicle } from "@shared/interfaces/vehicle.interface";

/**
 * Label of a vehicle in the report filters: "<code> - <license plate> - <description>".
 * The filter search matches this text, so the plate has to be in it for a search by plate to
 * find the vehicle. Empty parts are left out, so a vehicle without a plate reads "<code> - <description>".
 * @param vehicle Vehicle listed in the filter
 */
export const vehicleFilterLabel = (vehicle: Pick<Vehicle, "code" | "license_plate" | "description">): string => (
  [vehicle.code, vehicle.license_plate, vehicle.description]
    .map((part) => part?.trim())
    .filter((part) => !!part)
    .join(" - ")
);
